import { TCustomerField } from 'modules/checkout/domain/entities';
import { ICustomer } from 'shared/domain/entities';

/**
 * O que a etapa de finalizar cadastro precisa saber: quais campos pedir e qual sub-tela mostrar.
 *
 * Os campos não são mais deduzidos aqui. Quem diz o que falta é o Vectis, por perfil e por país,
 * e a lista chega pronta no orçamento — antes a tela cruzava duas listas fixas e olhava o objeto
 * do cliente, o que divergia do que o Vectis exigia no fechamento.
 *
 * As três marcas continuam sendo derivadas da lista, porque é a lista que descreve o estado do
 * cadastro: sem data de nascimento não dá para saber se o cliente é menor, e é por isso que os
 * dados do responsável só aparecem na consulta seguinte, depois que a data for informada.
 */
export default function getCustomerRegistrationMeta(
  customer: ICustomer | null,
  missingFields: TCustomerField[],
) {
  if (!customer) return null;

  return {
    rawData: customer,
    status: customer.minorityStatus,
    fields: missingFields,
    shouldConfirmDocument:
      missingFields.includes('document') && missingFields.includes('birthdate'),
    isMinorityUncertain: missingFields.includes('birthdate'),
    hasGuardian: Boolean(customer.guardian),
  };
}
